export const fetchBudgetTree = data => ({
  type: "FETCH_BUDGET_TREE",
  payload: data
});

export const initBudgetTree = () => ({
  type: "INIT_BUDGET_TREE"
});

export const initQuickBudgetClient = () => ({
  type: "INIT_QUICK_BUDGET_CLIENT"
});

export const fetchQuickBudgetClient = data => ({
  type: "FETCH_QUICK_BUDGET_CLIENT",
  payload: data
});

export const setQuickBudgetClient = item => {
  return {
    type: "SET_QUICK_BUDGET_CLIENT",
    item
  };
};

export const setBudgetPeriodeSetting = data => {
  return {
    type: "SET_BUDGET_PERIODE_SETTING",
    data
  };
};

export const saveQuickBudgetClient = resp => {
  return {
    type: "SAVE_QUICK_BUDGET",
    payload: resp
  };
};

export const initBudgetSettingClient = () => {
  return {
    type: "INIT_BUDGET_SETTING"
  };
};

export const setBudgetSettingClient = item => {
  return {
    type: "SET_BUDGET_SETTING_CLIENT",
    item
  };
};

export const fetchBudgetClient = data => {
  return {
    type: "FETCH_BUDGET_CLIENT",
    payload: data
  };
};

export const getCollaboratorBudget = data => {
  return {
    type: "FETCH_BUDGET_COLLABORATORS",
    payload: data
  };
};

export const updateBudgetClient = resp => ({
  type: "UPDATE_BUDGET_CLIENT",
  payload: resp
});

export const cloneAndSavedBudget = resp => ({
  type: "CLONE_BUDGET_CLIENT",
  payload: resp
});

export const setBudgetTreeSearchWord = searchWord => {
  return {
    type: "SET_BUDGET_TREE_SEARCH_WORD",
    searchWord
  };
};

export const setBudgetData = newBudgetData => {
  return {
    type: "SET_BUDGET_DATA",
    payload: newBudgetData
  };
};
export const setCollaborators = newCollaborators => {
  return {
    type: "SET_COLLABORATORS",
    payload: newCollaborators
  };
};

export const getBudgetStatesCount = budgetStates => {
  return {
    type: "GET_BUDGET_STATES_COUNT",
    payload: budgetStates
  };
};
export const updateBudgetByRole = data => ({
  type: "UPDATED_BUDGET_BY_ROLE",
  payload: data
});

export const getBudgetByRole = data => ({
  type: "GET_BUDGET_BY_ROLE",
  payload: data
});



// WEBPACK FOOTER //
// ./src/actions/actions/budget.js